// src/api/roles.js
import apiClient from './apiClient';

const RolesAPI = {
    getRoles() {
        return apiClient.get('/roles');
    },

    getPermissions() {
        // Obtiene la lista maestra de todos los permisos definidos
        return apiClient.get('/permissions');
    },

    /** OBTENER SOLO LA FILA BASE DEL ROL */
    getRoleDetails(id) {
        return apiClient.get(`/roles/${id}`);
    },

    /** NUEVO: Obtener las asignaciones de permisos de la tabla intermedia */
    getAssignedPermissions(roleId) {
        // Usa el filtro GET para obtener solo los permisos donde role_id = :roleId
        return apiClient.get(`/role_permissions?role_id=${roleId}`);
    },

    /**
     * Actualiza la información del rol y sus asignaciones de permisos.
     * La lógica compleja de borrar/reinsertar role_permissions debe manejarse en el backend PHP.
     */
    updateRolePermissions(id, payload) {
        return apiClient.put(`/roles/${id}`, payload);
    },

    // Métodos CRUD básicos (Crear, Eliminar)
    createRole(roleData) {
        return apiClient.post('/roles', roleData);
    },
};

export default RolesAPI;